module.exports = __webpack_public_path__ + "static/media/unreadMessage.b80d56be.svg";